import React, {FC, useEffect} from 'react'
import {useAppDispatch} from '../../../redux/config'
import {useSelector} from 'react-redux'
import {
  select_currentLegionCustomConfigOverrides,
  select_databaseIdToCopy,
  select_jobTypeOptions,
} from '../../../redux/databases/selectors'
import {fetchCustomConfigOverrides} from '../../../redux/databases/databases.duck'
import {Card, Hint, Spinner, Stack} from '@mdsol/onex-design'
import CustomConfigOverride from './CustomConfigOverride'
import {Status} from '../../../commonTypes'

const CustomConfigOverridesControls: FC = () => {
  const dispatch = useAppDispatch()
  const databaseId = useSelector(select_databaseIdToCopy)
  const {status, overridesByJobType} = useSelector(select_currentLegionCustomConfigOverrides)
  const jobTypeOptions = useSelector(select_jobTypeOptions)

  useEffect(() => {
    dispatch(fetchCustomConfigOverrides(databaseId, jobTypeOptions))
  }, [dispatch, databaseId, jobTypeOptions])

  return (
    <Stack className='custom-config-overrides'>
      <Card
        showTitleBar
        isExpanded={true}
        id='onex-components-card--info'
        variant='information'
        role='legion-custom-config-overrides-card'
        title='Custom Configuration Overrides'
        expandableBody={
          <Stack className='custom-config-overrides scrollable'>
            {status === Status.OK || status === Status.IDLE
              ? <>
                {
                  overridesByJobType.every(item => (item['overrides'] as []).length === 0)
                    ? <Stack direction='horizontal' className='value-wrapper'>
                      <Hint
                        dataTestId='hint-info'
                        variant='information'
                      >
                        No custom configuration overrides found.
                      </Hint>
                    </Stack>
                    : overridesByJobType.map((item) => {
                      if((item['overrides'] as []).length > 0){
                        const id = `${(item['jobType'] as string).trim().toLowerCase()}-id`
                        return (
                          <CustomConfigOverride
                            key={id}
                            id={id}
                            jobType={item['jobType']}
                            overrides={item['overrides']}
                          />
                        )
                      }
                    })
                }
              </>
              : <Stack direction='horizontal' className='value-wrapper'>
                {status === Status.PENDING ?
                  <Spinner dataTestId='overrides-details-spinner' size='sm'/>
                  : <Hint
                    dataTestId='hint-info'
                    variant='critical'
                  >
                    Unable to load custom configuration overrides at this time.
                  </Hint>
                }
              </Stack>
            }
          </Stack>
        }
      >
        <div className='hidden-card-body'></div>
      </Card>
    </Stack>
  )
}

export default CustomConfigOverridesControls
